import { render, staticRenderFns } from "./CPGlobalAccountSelect.vue?vue&type=template&id=48c12879&scoped=true&"
import script from "./CPGlobalAccountSelect.vue?vue&type=script&lang=ts&"
export * from "./CPGlobalAccountSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CPGlobalAccountSelect.vue?vue&type=style&index=0&id=48c12879&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c12879",
  null
  
)

export default component.exports